import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SROInfo from "../components/sro/SROInfo";
import SROSector from "../components/sro/SROSector";
import * as React from "react";
import Typography from "@mui/material/Typography";
import PotentialProjects from "../../project/containers/PotentialProjects";
import MultiLiteralPledgeInfo from "../components/MultiLiteralPledgeInfo";
import PledgeStatus from "../components/PledgeStatus";


interface IPPTabsProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: IPPTabsProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
interface IProps{
    isEAD: boolean
}

const PotentialProjectTabs = (props: IProps) => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    return (
        <React.Fragment>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={value} onChange={handleChange} aria-label="sro tabs">
                    <Tab label="Potential Projects" {...a11yProps(0)} />
                    <Tab label="SRO Info" {...a11yProps(1)} />
                    <Tab label="SRO Sectors" {...a11yProps(2)} />
                    <Tab label="Pledge Info" {...a11yProps(3)} />
                    <Tab label="Pledge Status" {...a11yProps(4)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <PotentialProjects isEAD={props.isEAD}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SROInfo/>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <SROSector/>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <MultiLiteralPledgeInfo />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <PledgeStatus />
            </TabPanel>


        </React.Fragment>
    )
}
export default PotentialProjectTabs
